import styled from 'styled-components';
import Grid from '@quintoandar/cozy-core/Grid';

export const GridWrapper = styled(Grid)`
    text-align: ${(props) => props.isMobile ? 'center' : 'initial'};
`;

export const AlignedGrid = styled(Grid)`
    text-align: ${(props) => props.isMobile ? 'center' : 'end'};
`;
